import CloseIcon from "@styles/all-images/icons/closeblack.svg";
import Documnet from "@styles/all-images/images/main-content-image.png";

interface ViewTermsSheetModalProps {
  onClose: () => void;
}

const ViewTermsSheetModal = ({ onClose }: ViewTermsSheetModalProps) => {
  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-lg tw-w-[600px]">
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-4 tw-border-b">
          <h2 className="tw-text-base tw-font-semibold">
            Terms Sheet Document 1
          </h2>
          <button onClick={onClose}>
            <img src={CloseIcon} alt="Close" className="tw-w-auto tw-h-auto" />
          </button>
        </div>
        <div className="tw-p-4">
          <img src={Documnet} alt="Document" className="tw-w-full tw-h-auto" />
        </div>
      </div>
    </div>
  );
};

export default ViewTermsSheetModal;
